import { popinOptinConstants } from '../../../../constants';
import { getRootUrl } from '../../../../utils';
export const subscribe = async (event, userSubscriptionInfo, onSuccess, onError) => {
    event.preventDefault();
    if (!userSubscriptionInfo) {
        return;
    }
    const endpointUrl = `${getRootUrl()}/${popinOptinConstants.url.updateSubscriptionUrl}`;
    // Sanitize: never send smsSubscriptions as opted-in without a phone number
    const sanitizedInfo = { ...userSubscriptionInfo };
    if (!sanitizedInfo.phone) {
        sanitizedInfo.smsSubscriptions = (sanitizedInfo.smsSubscriptions ?? []).map((sub) => ({ ...sub, status: false }));
    }
    try {
        const response = await fetch(endpointUrl, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(sanitizedInfo),
        });
        if (!response.ok) {
            onError(`Error: ${response.status} ${response.statusText}`);
            return;
        }
        onSuccess();
    }
    catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred on subscribe.';
        onError(errorMessage);
    }
};
